import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from "reactstrap";
import MenuTap from "../../../components/common/menu-tap";
import BreadCrumb from "../../../components/common/bread-crumb";
import TableModify from "../../../components/common/table-modify";
import Select from "react-select";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ConfigData from '../../../config.json';
import { handlerRespError } from "../../../components/utility/handler_resp";
import { useHistory } from "react-router-dom";

const SubDepartmentList = () => {
    const [isShowModal, setIsShowModal] = useState();
    const [dataTable, setDataTable] = useState([]);
    const [dataDepartment, setDataDepartment] = useState([]);
    const [selectedBusinessUnit, setSelectedBusinessUnit] = useState("");
    const [ddlBusinessUnit, setDdlBusinessUnit] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [ddlDepartment, setDdlDepartment] = useState([]);
    const [dataDetail, setDataDetail] = useState({
        id: 0,
        id_business_unit: "",
        id_department: "",
        code: "",
        name: "",
        remark: ""
    });
    const history = useHistory();

    useEffect(() => {
        LoadDataTable();
        LoadDataDdlBusinessUnit();
        LoadDataDepartment();
    }, []);

    const column = [
        {
            key: "id",
            name: <span className='font-weight-bold fs-13'>No.</span>,
            cell: (row, index) => index+1,
            width: "5%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: false
        },
        {
            key: "name_business_unit",
            name: <span className='font-weight-bold fs-13'>Business unit</span>,
            cell: (row, index) => row.name_business_unit,
            width: "25%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_department",
            name: <span className='font-weight-bold fs-13'>Department</span>,
            cell: (row, index) => row.name_department,
            width: "25%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "code",
            name: <span className='font-weight-bold fs-13'>Code</span>,
            cell: (row, index) => row.code,
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name",
            name: <span className='font-weight-bold fs-13'>Name</span>,
            cell: (row, index) => row.name,
            width: "25%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "action",
            name: <span className='font-weight-bold fs-13'></span>,
            cell: (row, index) => {
                return(
                    <UncontrolledDropdown key={index}>
                        <DropdownToggle tag="button" className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-2-fill"></i></DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <li>
                                <DropdownItem onClick={() => onClickUpdate(row)}>
                                    <i className="ri-pencil-fill"></i> Edit
                                </DropdownItem>
                            </li>
                            <li>
                                <DropdownItem onClick={() => onClickDelete(row.id)}>
                                    <i className="ri-delete-bin-line"></i> Delete
                                </DropdownItem>
                            </li>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                )
            },
            width: "10%",
            classHeader: "text-start",
            classBody: "text-end",
            sortable: false
        }
    ];

    const onClickAdd = () => {
        // setDdlDepartment([]);
        setDdlDepartment(dataDepartment);
        validation.resetForm();
        setSelectedBusinessUnit(null);
        setSelectedDepartment(null);
        setDataDetail({
            id: 0,
            id_business_unit: "",
            id_department: "",
            code: "",
            name: "",
            remark: ""
        });
        setIsShowModal(!isShowModal);
    };

    const onClickUpdate= (data) => {
        validation.resetForm();
        setSelectedBusinessUnit(ddlBusinessUnit.find(x => x.value === data.id_business_unit.toString()));
        // setDdlDepartment(dataDepartment.filter((e) => e.id_business_unit === data.id_business_unit.toString()));
        setDdlDepartment(dataDepartment);
        setSelectedDepartment(dataDepartment.find(x => x.value === data.id_department.toString()));
        setDataDetail({
            id: data.id,
            code: data.code,
            id_business_unit: data.id_business_unit,
            id_department: data.id_department,
            name: data.name,
            remark: data.remark
        });
        
        setIsShowModal(!isShowModal);
    };

    const onClickDelete = (id) => {
        Swal.fire({
            title: 'Are you sure ?',
            text: 'Once you delete, you can not undo it!',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#dc3741',
        }).then((result) => {
            if(result.isConfirmed){
                DeleteSubDepartment(id);
            }
        });
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_business_unit: dataDetail.id_business_unit || "",
            id_department: dataDetail.id_department || "",
            code: dataDetail.code || "",
            name:  dataDetail.name || "",
            remark: dataDetail.remark || "",
        },
        validationSchema: Yup.object({
            id_business_unit: Yup.string().required("Please select a business unit"),
            // id_department: Yup.string().required("Please select a department"),
            code: Yup.string().required("Please enter a Code"),
            name: Yup.string().required("Please enter a Name"),
        }),
        onSubmit: (values) => {
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            values.id_department = (values.id_department !== "") ? parseInt(values.id_department) : 0;
            if(values.id > 0){
                UpdateSubDepartment(values);
            }else{
                AddSubDepartment(values);
            }
        }
    });

    const LoadDataTable = () => {
        let url = ConfigData.API_URL + "sub-department/?status=1";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataTable(respData.data);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDdlBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlBusinessUnit(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDepartment = () => {
        let url = ConfigData.API_URL + "department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                    };
                });
                setDataDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const AddSubDepartment = (data) => {
        let url = ConfigData.API_URL + "sub-department/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.post(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(!isShowModal);
                Swal.fire({
                    icon: 'success',
                    title: 'Add data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to add data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const UpdateSubDepartment = (data) => {
        let url = ConfigData.API_URL + "sub-department/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.put(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Edit data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to edit data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const DeleteSubDepartment = (id) => {
        let url = ConfigData.API_URL + "sub-department/" + id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                Swal.fire({
                    icon: 'success',
                    title: 'Delete data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };


    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Sub Departments" pageTitle="Data settting" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <MenuTap type="company-structure" idActive="3" />
                                    <TableModify data={dataTable} column={column} rowPerPage={25} onClickAdd={onClickAdd} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* Modal Add and Edit */}
            <Modal id="modalSubDepartment"
                isOpen={isShowModal}
                toggle={() => { setIsShowModal(!isShowModal); }}
                backdrop={'static'}
                centered
            >
                <ModalHeader id="modalSubDepartmentHeader" 
                    className="modal-title"
                    toggle={() => { setIsShowModal(!isShowModal); }}
                >
                    {(dataDetail.id <= 0) ? "Create sub department" : "Edit sub department"}
                </ModalHeader>
                <ModalBody>
                    <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlBusinessUnit">Business unit</Label>
                                    <Select id="ddlBusinessUnit"
                                        name="id_business_unit"
                                        value={selectedBusinessUnit}
                                        onChange={(selected) => {
                                            setSelectedBusinessUnit(selected);
                                            let id_business_unit = (selected !== null) ? selected.value : "";
                                            // setDdlDepartment(dataDepartment.filter((e) => e.id_business_unit === id_business_unit));
                                            // setSelectedDepartment(null);
                                            validation.handleChange('id_business_unit')(id_business_unit);
                                            // validation.handleChange('id_department')("");
                                        }}
                                        options={ddlBusinessUnit}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                    />
                                    { validation.touched.id_business_unit && validation.errors.id_business_unit ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_business_unit}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlDepartment">Department</Label>
                                    <Select id="ddlDepartment"
                                        name="id_department"
                                        value={selectedDepartment}
                                        onChange={(selected) => {
                                            setSelectedDepartment(selected);
                                            validation.handleChange('id_department')((selected !== null) ? selected.value : "");
                                        }}
                                        options={ddlDepartment}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_department && validation.errors.id_department ? true : false }
                                    />
                                    { validation.touched.id_department && validation.errors.id_department ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_department}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtCode">Code</Label>
                                    <Input id="txtCode" 
                                        name="code"
                                        placeholder="Code"
                                        type="text"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.code || ""}
                                        invalid={ validation.touched.code && validation.errors.code ? true : false }
                                    />
                                    { validation.touched.code && validation.errors.code ? 
                                        ( <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtName">Name</Label>
                                    <Input id="txtName" 
                                        name="name"
                                        placeholder="Name"
                                        type="text"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.name || ""}
                                        invalid={ validation.touched.name && validation.errors.name ? true : false }
                                    />
                                    { validation.touched.name && validation.errors.name ? 
                                        ( <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtRemark">Remark</Label>
                                    <Input id="txtRemark" 
                                        name="remark"
                                        placeholder="Remark"
                                        type="textarea"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.remark || ""}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <Button color="primary" type="button" onClick={() => setIsShowModal(false) } >
                                    Close
                                </Button>
                                <Button className="float-end" color="success" type="submit">
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default SubDepartmentList;